/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Category_QuestionInputs */

const en_feedback_category_question = /** @type {(inputs: Feedback_Category_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Question`)
};

const de_feedback_category_question = /** @type {(inputs: Feedback_Category_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frage`)
};

const fr_feedback_category_question = /** @type {(inputs: Feedback_Category_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Question`)
};

const es_feedback_category_question = /** @type {(inputs: Feedback_Category_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pregunta`)
};

const it_feedback_category_question = /** @type {(inputs: Feedback_Category_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domanda`)
};

const nl_feedback_category_question = /** @type {(inputs: Feedback_Category_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vraag`)
};

const pl_feedback_category_question = /** @type {(inputs: Feedback_Category_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pytanie`)
};

const fi_feedback_category_question = /** @type {(inputs: Feedback_Category_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kysymys`)
};

const da_feedback_category_question = /** @type {(inputs: Feedback_Category_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spørgsmål`)
};

const sv_feedback_category_question = /** @type {(inputs: Feedback_Category_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fråga`)
};

/**
* | output |
* | --- |
* | "Question" |
*
* @param {Feedback_Category_QuestionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const feedback_category_question = /** @type {((inputs?: Feedback_Category_QuestionInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Category_QuestionInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_feedback_category_question(inputs)
	if (locale === "fr") return fr_feedback_category_question(inputs)
	if (locale === "es") return es_feedback_category_question(inputs)
	if (locale === "it") return it_feedback_category_question(inputs)
	if (locale === "nl") return nl_feedback_category_question(inputs)
	if (locale === "pl") return pl_feedback_category_question(inputs)
	if (locale === "fi") return fi_feedback_category_question(inputs)
	if (locale === "da") return da_feedback_category_question(inputs)
	if (locale === "sv") return sv_feedback_category_question(inputs)
	return en_feedback_category_question(inputs)
});